import React from 'react';

const Context = React.createContext({tier: process.env.REACT_APP_TIER});

export default Context;
